import React, {useContext} from "react";
import {ConfiguratorContext} from "../../../context";
import {useQuoteContext} from "../../../contexts/QuoteContext";
import Utils from "../../../util/util";
import {Alert} from "antd";
import {Link} from "react-router-dom";

const PendingSplitAlert = () => {

    const configurator = useContext(ConfiguratorContext);
    const { quote } = useQuoteContext();

    const {
        isPendingSplit
    } = Utils.getQuoteState(configurator, quote );

    if ( !isPendingSplit ) return <></>;

    return <Alert
        type={"warning"}
        message={<>
            This quote is part of pending a split change. It depends on the following quotes:
            <ul>
                {quote?.approvalGroups
                    ?.flatMap(ag => ag.quoteRevisions)
                    .filter( qr => qr.quoteId !== quote.quoteId)
                    .map(partner => (
                        <li key={partner.quoteId}>
                            <Link style={{ marginLeft: "5px", marginRight: "5px" }} to={"/configurator/" + encodeURI(partner.quoteId)} target={"_blank"}>
                                {partner.quoteId}
                            </Link>
                        </li>
                    ))}
            </ul>
        </>}
    />
}

export default PendingSplitAlert;
